import React from "react";
import { StyledSVG, Wrapper } from "./IconStyle";
import { useLocation } from "react-router";

export const routeActiveReport = ["report", "report-details"];

const ReportIcon = () => {
  const { pathname } = useLocation();
  return (
    <Wrapper>
      {routeActiveReport.some((item) =>
        item.includes(pathname.split("/")[1])
      ) ? (
        <StyledSVG
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.1667 20.8543H4.58337C2.68587 20.8543 1.14587 19.3143 1.14587 17.4168V1.8335C1.14587 1.45766 1.45754 1.146 1.83337 1.146C2.20921 1.146 2.52087 1.45766 2.52087 1.8335V17.4168C2.52087 18.5535 3.44671 19.4793 4.58337 19.4793H20.1667C20.5425 19.4793 20.8542 19.791 20.8542 20.1668C20.8542 20.5427 20.5425 20.8543 20.1667 20.8543Z"
            fill="#20A2A2"
          />
          <path
            d="M4.58321 16.271C4.42738 16.271 4.26238 16.216 4.13404 16.106C3.84988 15.8585 3.81321 15.4277 4.06071 15.1343L8.26821 10.221C8.72654 9.68932 9.38654 9.3685 10.0832 9.341C10.7799 9.32266 11.4674 9.57932 11.9624 10.0743L12.8332 10.9452C13.0624 11.1743 13.3649 11.2843 13.6857 11.2843C14.0065 11.2752 14.2999 11.1285 14.5107 10.881L18.7182 5.96767C18.9657 5.6835 19.3965 5.64682 19.6899 5.89432C19.974 6.14182 19.8846 6.34531 19.8846 6.87533C19.8846 6.87533 19.8846 13.8575 19.8846 14.7206C19.8846 15.5837 20.1667 16.271 19.25 16.271C18.3334 16.271 18.0395 16.271 18.0395 16.271H16.1944C15.6765 16.271 15.3578 16.271 14.6667 16.271C13.9756 16.271 14.3516 16.271 13.6857 16.271H12.0362C11.4584 16.271 11.0447 16.2618 10.7239 16.271C10.4031 16.2802 10.0834 16.271 9.62504 16.271H5.04171C4.58337 16.271 4.77571 16.271 4.58321 16.271Z"
            fill="#20A2A2"
          />
        </StyledSVG>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.58337 20.9043H20.1667C20.5702 20.9043 20.9042 20.5703 20.9042 20.1668C20.9042 19.7634 20.5702 19.4293 20.1667 19.4293H4.58337C3.47432 19.4293 2.57087 18.5259 2.57087 17.4168V1.8335C2.57087 1.43005 2.23682 1.096 1.83337 1.096C1.42993 1.096 1.09587 1.43005 1.09587 1.8335V17.4168C1.09587 19.3419 2.65826 20.9043 4.58337 20.9043Z"
            fill="#454F5B"
            stroke="#454F5B"
            stroke-width="0.1"
          />
          <path
            d="M4.06836 16.1814L4.06897 16.1819C4.21653 16.3084 4.405 16.371 4.58321 16.371C4.80461 16.371 5.02306 16.2761 5.1877 16.1012L5.18778 16.1013L5.19083 16.0977L9.39833 11.1844L9.3985 11.1842C9.59196 10.9571 9.85916 10.8243 10.1502 10.816C10.4436 10.8076 10.7194 10.9162 10.929 11.1257C10.929 11.1257 10.9291 11.1258 10.9292 11.1259L11.7905 11.9963L11.7908 11.9967C12.3064 12.5123 13.0209 12.7783 13.7433 12.7593L13.7433 12.7593L13.7447 12.7592C14.4694 12.7306 15.1552 12.397 15.6315 11.8446L15.6317 11.8444L19.8392 6.93103L19.8396 6.93047C20.1225 6.59517 20.0807 6.10209 19.7556 5.81891L19.7556 5.8189L19.7544 5.81789C19.4191 5.53498 18.926 5.57687 18.6428 5.90199L18.6423 5.90263L14.4348 10.8159L14.4346 10.8161C14.2414 11.0429 13.9748 11.1756 13.6843 11.1843C13.3873 11.184 13.1118 11.0824 12.9039 10.8745L12.0331 10.0036C11.5175 9.48805 10.803 9.22202 10.0806 9.24102L10.0793 9.24108C9.35457 9.26968 8.66868 9.60329 8.19247 10.1557L8.19226 10.1559L3.98475 15.0693L3.98428 15.0699C3.70137 15.4052 3.74324 15.8982 4.06836 16.1814Z"
            fill="#454F5B"
            stroke="#454F5B"
            stroke-width="0.2"
          />
        </svg>
      )}
    </Wrapper>
  );
};

export default ReportIcon;
